import * as React from 'react'
import { Accordion, Button, Card, Form, Image } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { companyObj, CompanyT } from '../../../types/Company'
import config from '../../../constants/config'
import InsurancePolicy, { PolicyType } from '../../../types/InsurancePolicy'
import { copyObject } from '../../../utils'
import { IAppState } from '../../../redux/reducers'
import { AxiosInstance } from '../../../utils/RequestMethods'


/*
TODO:   The insurance list we ultimately end up pulling from the db will be stored as a
        reverse chronological order record of this.  When uploading policies, we need to
        add some logic that sorts it prior to db persistence

        Or should it be chronological order?

        NOTE:  In the UI, we display the policies in reverse chronological order.  This is so the
        most recent policies are visible first.
*/
const INSURANCE_LIST : any = [
    {
        policyType: PolicyType['General Liability'],
        policies: [
            {
                id: 7,
                carrier: 'Progressive',
                coinsurance: 80,
                deductible: 1000.00,
                effectiveDate: moment('2020-1-1').format('MMM D, YYYY'),
                endorsements: [],
                expirationDate: moment('2020-6-30').format('MMM D, YYYY'),
                fkAdditionalInsured: [1, 2, 3],
                fkInsurer: 5,
                fkPrimaryNamedInsured: 5,
                limitAggregate: 50000.00,
                limitOccurrence: 25000.00,
                policyNumber: 'DF98DSFNAKEW',
                policyType: PolicyType['General Liability'],
                premium: 300.00,
                premiumDiscount: 25.00
            },
            {
                id: 12,
                carrier: 'Geico',
                coinsurance: 80,
                deductible: 1000.00,
                effectiveDate: moment('2020-7-1').format('MMM D, YYYY'),
                endorsements: [],
                expirationDate: moment('2020-12-31').format('MMM D, YYYY'),
                fkAdditionalInsured: [1, 2, 3],
                fkInsurer: 5,
                fkPrimaryNamedInsured: 5,
                limitAggregate: 50000.00,
                limitOccurrence: 25000.00,
                policyNumber: 'DF98DSFNAKEW',
                policyType: PolicyType['General Liability'],
                premium: 300.00,
                premiumDiscount: 25.00
            }
        ]
    },
    {
        policyType: PolicyType["Workers' Comp"],
        policies: [
            {
                id: 8,
                carrier: 'Pinnacol',
                coinsurance: 80,
                deductible: 8900.00,
                effectiveDate: moment('2019-1-1').format('MMM D, YYYY'),
                endorsements: [],
                expirationDate: moment('2019-6-30').format('MMM D, YYYY'),
                fkAdditionalInsured: [1, 2, 3],
                fkInsurer: 5,
                fkPrimaryNamedInsured: 5,
                limitAggregate: 50000.00,
                limitOccurrence: 25000.00,
                policyNumber: 'C4LKJSDFALKDJAF',
                policyType: PolicyType["Workers' Comp"],
                premium: 375.00,
                premiumDiscount: 30.00
            }
        ]
    }
]

interface InsuranceProps { }

const Insurance : React.FunctionComponent<InsuranceProps> = ({}) : JSX.Element => {
    let calculateInsList = (insOpt : string) : any => {
        return INSURANCE_LIST.filter(item => {
            return item.policyType === PolicyType[insOpt]
        })
    }

    const [activeInsurance, setActiveInsurance] = React.useState('Cargo')
    const [insList, setInsList] = React.useState(calculateInsList(activeInsurance))

    const [company, setCompany] = React.useState(copyObject(companyObj))
    const [isReady, setIsReady] = React.useState(false)

    const [showPurchaseInsurance, setShowPurchaseInsurance] = React.useState(false)

    let auth = useSelector((state:IAppState) => state.auth)
    let fk_companies = auth.userData.fk_companies ? auth.userData.fk_companies : []

    let fk_company = Object.keys(fk_companies).map(key => {
        if (key == '0') {
            return fk_companies[key]
        }
    })[0]

    React.useEffect((): void => {
        console.log('in Settings->useEffect')
        console.log("fk_company", fk_company)
        if (fk_company == null || fk_company == undefined)  {
            setIsReady(true)
        } else {
            AxiosInstance.get(`${config.url.companies}/${fk_company}`).then((res) => {
                if (res && res.data) {
                    setCompany(res.data)
                    console.log('res data', res.data)
                }
                setIsReady(true)
            }).catch((error) => {
                console.log('FALSE: ', error)
                setIsReady(true)
            })
        }
    }, [])

    const buttonBlock = (insType : string) : JSX.Element => {
        return (
            <div>
                <div>
                    <Button
                        variant='info'
                        onClick={() => {setShowPurchaseInsurance(!showPurchaseInsurance)}}>
                        Purchase Insurance
                    </Button>
                    <Button variant='light'>Upload COI</Button>
                </div>
                {showPurchaseInsurance == true &&
                    <div>
                        <p>{insType}  Upon submission, you will be connected with a Smuvs Insurance Broker.</p>
                    </div>}
            </div>
        )
    }

    const changeActiveIns = (insOpt : string) : void => {
        setActiveInsurance(insOpt)
        setInsList(calculateInsList(insOpt))
        console.log('insOpt', insOpt)
    }

    const renderPolicies = () : JSX.Element => {
        console.log('iiiList', insList)
        return (
            <Accordion>
                {insList[0].policies.map((item : any, index : number) => {
                    return (
                        <>
                            <Card.Header>
                                <Accordion.Header as={Button} variant="link" eventKey={index.toString()}>
                                    <div>
                                        <h5>{item.carrier} - {item.effectiveDate.toString()} to {item.expirationDate.toString()}</h5>
                                    </div>
                                </Accordion.Header>
                            </Card.Header>
                            <Accordion.Collapse eventKey={index.toString()}>
                                <Form>
                                    <Form.Group>
                                        <Form.Label>Policy Number</Form.Label>
                                        <Form.Control className='input-material' />
                                        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                                            <span>
                                                <Form.Label>Effective Date</Form.Label>
                                                <Form.Control className='input-material' />
                                            </span>
                                            <span>
                                                <Form.Label>Expiration Date</Form.Label>
                                                <Form.Control className='input-material' />
                                            </span>
                                        </div>
                                        {/*<Form.Label>Vehicle Identification Number (VIN)</Form.Label>
                                        <Form.Control className='input-material' />*/}
                                        <Button variant='success'>Save Policy</Button>
                                        <Button variant='danger'>Delete Policy</Button>
                                    </Form.Group>
                                </Form>
                            </Accordion.Collapse>
                        </>
                    )
                })}
            </Accordion>
        )
    }

    return (
        <div>
            <span>
                <Button variant='outline-primary' onClick={() => {changeActiveIns('Cargo')}}>Cargo</Button>{' '}
                <Button variant='outline-primary' onClick={() => {changeActiveIns('Commercial Trucking')}}>Commercial Trucking</Button>{' '}
                <Button variant='outline-primary' onClick={() => {changeActiveIns('General Liability')}}>General Liability</Button>{' '}
                <Button variant='outline-primary' onClick={() => {changeActiveIns("Workers' Comp")}}>Workers' Comp</Button>{' '}
            </span>
            {activeInsurance == 'Cargo' &&
                <div>
                    <h1>Cargo Policies</h1>
                    {insList.length == 0 &&
                        <p className='text-danger'>
                            You do not have any Cargo Policies on file.  Purchase a policy or upload your COI.
                        </p>}
                    {buttonBlock('Cargo')}
                    {insList.length > 0 && renderPolicies()}
                </div>}
            {activeInsurance == 'Commercial Trucking' &&
                <div>
                    <h1>Commercial Trucking Policies</h1>
                    {insList.length == 0 &&
                        <p className='text-danger'>
                            You do not have any Commercial Trucking Policies on file.  Purchase a policy or upload your COI.
                        </p>}
                    {buttonBlock('Commercial Trucking')}
                    {insList.length > 0 && renderPolicies()}
                </div>}
            {activeInsurance == 'General Liability' &&
                <div>
                    <h1>General Liability Policies</h1>
                    {insList.length == 0 &&
                        <p className='text-danger'>
                            You do not have any General Liability Policies on file.  Purchase a policy or upload your COI.
                        </p>}
                    {buttonBlock('General Liability')}
                    {insList.length > 0 && renderPolicies()}
                </div>}
            {activeInsurance == "Workers' Comp" &&
                <div>
                    <h1>Workers' Comp Policies</h1>
                    {insList.length == 0 &&
                        <p className='text-danger'>
                            You do not have any Workers' Comp Policies on file.  Purchase a policy or upload your COI.
                        </p>}
                    {buttonBlock("Workers' Comp")}
                    {insList.length > 0 && renderPolicies()}
                </div>}
        </div>
    )
}

export default Insurance
